module.exports = __webpack_public_path__ + "assets/img/home2-box2-2.d3f3fd82.png";